"use strict";

exports.__esModule = true;

var _tokenTypes = require("./tokenTypes");

var _tokenTypes2 = _interopRequireDefault(_tokenTypes);

var _trimEnd = require("lodash/trimEnd");

var _trimEnd2 = _interopRequireDefault(_trimEnd);

var _endsWith = require("lodash/endsWith");

var _endsWith2 = _interopRequireDefault(_endsWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var INLINE_MAX_LENGTH = 50;
var NEW_LINE_REG = /\r?\n/;

/**
 * Bookkeeper for inline blocks.
 *
 * Inline blocks are parenthized expressions that are shorter than INLINE_MAX_LENGTH.
 * These blocks are formatted on a single line, unlike longer parenthized
 * expressions where open-parenthesis causes newline and increase of indentation.
 */

var InlineBlock = function () {
    function InlineBlock() {
        _classCallCheck(this, InlineBlock);

        this.level = 0;
    }

    /**
     * Begins inline block when lookahead through upcoming tokens determines
     * that the block would be smaller than INLINE_MAX_LENGTH.
     * @param  {Object[]} tokens Array of all tokens
     * @param  {Number} index Current token position
     */


    InlineBlock.prototype.beginIfPossible = function beginIfPossible(tokens, index) {
        if (this.level === 0 && this.isInlineBlock(tokens, index)) {
            this.level = 1;
        } else if (this.level > 0) {
            this.level++;
        } else {
            this.level = 0;
        }
    };

    /**
     * Finishes current inline block.
     * There might be several nested ones.
     */


    InlineBlock.prototype.end = function end() {
        this.level--;
    };

    /**
     * True when inside an inline block
     * @return {Boolean}
     */


    InlineBlock.prototype.isActive = function isActive() {
        return this.level > 0;
    };

    // Check if this should be an inline parentheses block
    // Examples are "NOW()", "COUNT(*)", "int(10)", key(`somecolumn`), DECIMAL(7,2)
    // true表示不换行


    InlineBlock.prototype.isInlineBlock = function isInlineBlock(tokens, index) {
        var length = 0;
        var level = 0;

        if (this.isSubQuery(tokens, index)) {
            return false;
        }

        for (var i = index; i < tokens.length; i++) {
            var token = tokens[i];
            length += (0, _trimEnd2["default"])(token.value).length;

            // Overran max length or has Enter in block sql
            if (length > INLINE_MAX_LENGTH || NEW_LINE_REG.test(token.value)) {
                return false;
            }

            if (token.type === _tokenTypes2["default"].OPEN_PAREN) {
                level++;
            } else if (token.type === _tokenTypes2["default"].CLOSE_PAREN) {
                level--;
                if (level === 0) {
                    return true;
                }
            }

            if (this.isForbiddenToken(token)) {
                return false;
            }
        }
        return false;
    };

    /** 原先通过括号内长度来判断是否换行。但是在函数计算中，会显得很乱。此处改成仅子查询换行，非子查询则不换行 */


    InlineBlock.prototype.isSubQuery = function isSubQuery(tokens, index) {
        var i = index - 1;
        var wordBeforeBracket = tokens[i];
        // 避免无聊的用括号一直包。。导致不想要的格式化异常
        while (wordBeforeBracket && [_tokenTypes2["default"].OPEN_PAREN, _tokenTypes2["default"].WHITESPACE].includes(wordBeforeBracket.type)) {
            i = i - 1;
            wordBeforeBracket = tokens[i];
        }
        // 此处用，括号前面的有效关键词，是否为from。来判断是否是子查询。不是子查询则inlineBlock为true
        // split空格的目的
        var preWord = String(wordBeforeBracket.value).toLowerCase();

        return ['from'].includes(preWord) || (0, _endsWith2["default"])(preWord, 'join');
    };

    // Reserved words that cause newlines, comments and semicolons
    // are not allowed inside inline parentheses block


    InlineBlock.prototype.isForbiddenToken = function isForbiddenToken(_ref) {
        var type = _ref.type,
            value = _ref.value;

        return value === "SELECT" || type === _tokenTypes2["default"].RESERVED_TOPLEVEL ||
        // type === tokenTypes.RESERVED_NEWLINE ||
        type === _tokenTypes2["default"].COMMENT || type === _tokenTypes2["default"].BLOCK_COMMENT || value === ";";
    };

    return InlineBlock;
}();

exports["default"] = InlineBlock;
module.exports = exports["default"];